module.exports = __webpack_public_path__ + "static/media/feedback.729108c5.png";